<template>
  <div class="base">
    <inside-header />
    <div class="main">
      <div class="title">
        {{ cloud.title }}
      </div>
      <div class="content" v-html="cloud.content" />
    </div>
    <main-footer />
  </div>
</template>
<script>
import { MainFooter, InsideHeader } from '@/components'

export default {
  name: 'Moment',
  components: {
    MainFooter,
    InsideHeader
  },
  props: { // 接受传入的数据
    id: {}
  },
  data() {
    return {
      cloud: {}
    }
  },
  created() {
    this.loadData(this.id)// 获取到props里的id并调用函数loadData
  },
  methods: {
    loadData(e) {
      this.$http({
        url: 'index/helps/info',
        method: 'get',
        params: {
          id: e
        }
      }).then(res => {
        console.log(res)
        if (res.status === 'success') {
          var data = res.data
          this.cloud = data.info
        } else {
          this.$toast.fail('系统繁忙,请刷新重试')
        }
      })
    },
    goTutor() {
      console.log(1)
    }
  }
}
</script>
<style lang="stylus">
.base {
    min-width: 280px;
    max-width: 420px;
    margin: auto;
    background-color: #fff;
}

.top-title {
  width: 100%;
  height: 44px;
  line-height: 44px;

  padding: 0 10px;

  .title {
    margin-left: 10px;
  }
}

.main {
  padding: 0 15px;

  .title {
    font-family: PingFang-SC-Bold;
    font-size: 21px;
    line-height: 30px;
    letter-spacing: 0px;
    color: #333333;
    font-weight: bold;
  }

  .content {
    margin-top: 30px;
  }
}
</style>
